import { motion } from "framer-motion";

/**
 * Slow editorial marquee. Duplicates content once so it can wrap seamlessly.
 * items: array of strings.
 */
export const Marquee = ({ items, duration = 50, className = "" }) => {
  const track = [...items, ...items];
  return (
    <div className={`overflow-hidden border-y border-navy/10 bg-paper ${className}`} data-testid="editorial-marquee">
      <motion.div
        className="flex whitespace-nowrap py-8"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ repeat: Infinity, duration, ease: "linear" }}
      >
        {track.map((t, i) => (
          <span
            key={i}
            className="font-heading italic font-light text-navy text-5xl md:text-7xl leading-none px-10 flex items-center"
          >
            {t}
            <span className="mx-8 text-brass text-3xl md:text-5xl not-italic">✦</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};
